/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { OpenFilePayload } from './OpenFilePayload';
import {
    OpenFilePayloadFromJSON,
    OpenFilePayloadFromJSONTyped,
    OpenFilePayloadToJSON,
} from './OpenFilePayload';

/**
 * 
 * @export
 * @interface OpenFileResponse
 */
export interface OpenFileResponse {
    /**
     * 
     * @type {Array<Message>}
     * @memberof OpenFileResponse
     */
    messages?: Array<Message>;
    /**
     * 
     * @type {OpenFilePayload}
     * @memberof OpenFileResponse
     */
    payload?: OpenFilePayload;
}

/**
 * Check if a given object implements the OpenFileResponse interface.
 */
export function instanceOfOpenFileResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OpenFileResponseFromJSON(json: any): OpenFileResponse {
    return OpenFileResponseFromJSONTyped(json, false);
}

export function OpenFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenFileResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messages': !exists(json, 'messages') ? undefined : ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : OpenFilePayloadFromJSON(json['payload']),
    };
}

export function OpenFileResponseToJSON(value?: OpenFileResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messages': value.messages === undefined ? undefined : ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': OpenFilePayloadToJSON(value.payload),
    };
}

